<template>
    <div>
        <div class="card card-body p-0" id="card_body" style="border-radius: 10px">
            <task-filter :developers="developers" :orgList="orgList" @setPage="setPage" @selectedTaskTab="selTab" @skeletonLoader="setSkeletonLoader" :tasks="tasks" :teams="teams" @update-parent-filters="updateParentFilters" :weekendFiltersProp="weekendFilters" @filteredTasks="getFilteredTasks"></task-filter>
            <task-table :developers="developers" :orgList="orgList" :totalPages="totalPages" :totalRows="totalRows" :page="page" @setPage="setPage" :tasks="tasks" :setSkeletonLoader="displayLoader" :selTab="status" :weekendDaysProp="weekendDays" :teams="teams"
            @update-sortingby-variable="updateSortingByVariable" :filteredTasksProp="filteredTasks"></task-table>
          

        </div>
    </div>
</template>
<script>
    import helpers from "@/helpers.js";
    import taskTable from '../common/designer/task/table';
    import taskFilter from '../common/designer/task/filter';
    import axios from 'axios';
    export default {
        data:function(){
            return{
                activeTaskType: {},
                filteredTasks:[],
                orgList:[],
                page: 0,
                displayLoader: true,
                status:'',
                developers:[],
                filters: {},
                sortingBy: {},
                weekendFilters: ['Last week', 'This week', 'Next week'],
                weekendDays: [ "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday","Sunday"],
            };
        },
        components: {
            taskFilter, taskTable,
        },
        computed:{
            tasks: function () {
                return this.$store.getters['tasks/tasks'];
            },
            totalPages: function () {
                return this.$store.getters["tasks/totalPages"];
            },
            totalRows: function () {
                return this.$store.getters["tasks/totalRows"];
            },
            teams: function () {
                return this.$store.getters["persist/teams"];
            },
            taskTypesList: function () {
                return this.$store.getters['tasks/taskTypesList'];
            },
        },
        beforeRouteUpdate(to, from, next) {
            const taskType = to.params.task_type;
            to.meta.breadcrumb = ` ${taskType} Tasks`;

            this.reloadComponent(to);
            next();
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.reloadComponent(to);
                next();
            });
        },
        created: function(){
            this.page = helpers.getPageQuery();
            this.getDevelopersList();
            this.getTeamsList();
            this.getOrganizations();
            
        },
         watch: {
            page: function (val) {
                this.setSkeletonLoader(true);
                this.$store.dispatch("tasks/getAllDesignerTask", [val, this.filters, this.sortingBy])
                .then(() => {
                    this.setSkeletonLoader(false);
                });
            },
            // page: function (val) {
            //     reloadComponent(val);
            // },
            // '$route.params': {
            //     handler: 'reloadComponent',
            //     deep: true,
            // }
         },
        methods:{
            getFilteredTasks:function(filteredTasks)
            {
               this.filteredTasks = filteredTasks;

            }
            ,
            reloadComponent (route) {
                let task_type = route.params.task_type;
                let breadcrumb = 'Tasks';
                if (task_type !== undefined) {
                    this.activeTaskType = this.taskTypesList.find(opt => opt.slug == task_type);
                    this.filters.task_type = this.activeTaskType.value;
                    // console.log(this.activeTaskType);
                    breadcrumb = `${this.activeTaskType.name} Tasks`
                } else {
                    this.activeTaskType = {};
                    this.filters.task_type = '';
                }
                route.meta.breadcrumb = breadcrumb;
                this.getRecords();
            },
            setPage(page) {
                 this.page = page;
                if(this.$route.query.page != 1){
                    if (this.activeTaskType.value != undefined) {
                        this.$router.push(this.activeTaskType.slug + "?page=" + page);
                    } else {
                        this.$router.push("task?page=" + page);
                    }
                }
            },
            getDevelopersList(){
                this.$store.dispatch("users/getUserList",['developer'])
                .then((res) => {
                    this.developers = res.map(({ id, full_name }) => ({id, full_name}));
                });
            },
            getTeamsList(){
                this.$store.dispatch("teams/getAll");
            },
            setSkeletonLoader(val){
                this.displayLoader = val;
            },
            getOrganizations(){
                this.$store.dispatch("organizations/getAll",[{status: 1}]).then((res) => {
                    this.orgList = res
                });
            },
            selTab(event) {
                this.status = event;
            },
            updateParentFilters: function (value) {
                this.filters = value;
            },
            updateSortingByVariable: function (value) {
                this.sortingBy = value;
            },
            getRecords(page = 1){
                this.setSkeletonLoader(true);
                this.$store.dispatch("tasks/getAllDesignerTask", [page, this.filters, this.sortingBy]).then(() => {
                    this.setSkeletonLoader(false);
                });
            },
        }
    }
</script>
<style scoped lang="scss">
.new_contract{
    border: 1px solid  rgb(72, 166, 166) !important;
    background: rgb(72, 166, 166) ;
    color: white;
    &:hover {
        background-color: #f0ed00;
        color: rgb(72, 166, 166) !important;
        background: white !important;
    }
}
</style>